import { render, staticRenderFns } from "./recoveryPassword0.vue?vue&type=template&id=6096eadb&scoped=true&"
import script from "./recoveryPassword0.vue?vue&type=script&lang=js&"
export * from "./recoveryPassword0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6096eadb",
  null
  
)

export default component.exports